export const COMMON_SET_PAGE_NOT_FOUND = 'common/set-page-not-found';
export const COMMON_RESET_PAGE_NOT_FOUND = 'common/reset-page-not-found';
export const COMMON_OPEN_POPUP = 'common/open-popup';
export const COMMON_CLOSE_POPUP = 'common/close-popup';

